import {TMonthDays, TWeekStart} from '../types';

const daysInMonth = (year: number, month: number) => new Date(year, month + 1, 0).getDate();

export const getMonthDays = (
  year: number,
  month: number,
  weekStart: TWeekStart = 1,
): TMonthDays => {
  const date = new Date(Date.UTC(year, month, 1, 0, 0, 0, 0));

  const days: TMonthDays = [];
  const firstDay = date.getUTCDay();
  const firstDate = -((7 - weekStart + firstDay) % 7);
  const lastDate = daysInMonth(year, month);
  const lastDay = (lastDate - firstDate) % 7;

  let currentDate = firstDate;

  const max = lastDate - currentDate + (lastDay !== 0 ? 7 - lastDay : 0) + firstDate;

  while (currentDate < max) {
    const day = currentDate + 1;
    const weekDay = ((currentDate < 1 ? 7 + currentDate : currentDate) + firstDay) % 7;

    if (day >= 1 && day <= lastDate) {
      days.push({
        day,
        weekDay,
        month,
        year,
      });
    } else {
      days.push(null);
    }

    currentDate += 1;
  }

  return days;
};
